// Adyen states an amount in its currency's minor units, and the number of decimals is Adyen's, not
// the browser's ISO 4217 table: Adyen's table (docs.adyen.com/development-resources/currency-codes)
// has no decimals for CVE and IDR and two for CLP and ISK, where ISO 4217 differs. A currency Adyen
// does not list is refused, never given a guessed number of decimals. The same table runs in
// Business Central and in the storefront block.
const ADYEN_CURRENCIES = new Set(
    (
        "AED ALL AMD AOA ARS AUD AWG AZN BAM BBD BDT BHD BMD BND BOB BRL BSD BWP BYN BZD " +
        "CAD CHF CLP CNH CNY COP CRC CUP CVE CZK DJF DKK DOP DZD EGP ETB EUR FJD FKP " +
        "GBP GEL GHS GIP GMD GNF GTQ GYD HKD HNL HTG HUF IDR ILS INR IQD ISK JMD JOD JPY " +
        "KES KGS KHR KMF KRW KWD KYD KZT LAK LKR LYD MAD MDL MKD MMK MNT MOP MRU MUR MVR " +
        "MWK MXN MYR MZN NAD NGN NIO NOK NPR NZD OMR PAB PEN PGK PHP PKR PLN PYG QAR RON " +
        "RSD RUB RWF SAR SBD SCR SEK SGD SHP SLE SOS SRD STN SVC SZL THB TND TOP TRY TTD " +
        "TWD TZS UAH UGX USD UYU UZS VEF VND VUV WST XAF XCG XCD XOF XPF YER ZAR ZMW"
    ).split(" ")
);
const ZERO_DECIMAL_CURRENCIES = new Set([
    "CVE", "DJF", "GNF", "IDR", "JPY", "KMF", "KRW", "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF",
]);
const THREE_DECIMAL_CURRENCIES = new Set(["BHD", "IQD", "JOD", "KWD", "LYD", "OMR", "TND"]);
const MONEY_LOCALE = "en-GB";
const DECIMAL_BASE = 10;

export function minorUnitExponent(currencyCode) {
    if (typeof currencyCode !== "string" || currencyCode === "") {
        throw new Error("An amount cannot be shown without its currency code.");
    }
    if (!ADYEN_CURRENCIES.has(currencyCode)) {
        throw new Error(`Adyen does not list the currency ${currencyCode}, so the amount cannot be shown.`);
    }
    if (ZERO_DECIMAL_CURRENCIES.has(currencyCode)) return 0;
    if (THREE_DECIMAL_CURRENCIES.has(currencyCode)) return 3;
    return 2;
}

// The page shows exactly the amount the shopper is charged: the currency's minor-unit decimals are
// always shown and never rounded away.
export function formatMinorUnitsAsMoney(amountInMinorUnits, currencyCode) {
    if (!Number.isSafeInteger(amountInMinorUnits) || amountInMinorUnits < 0) {
        throw new Error("The amount is not a whole number of the currency's minor units.");
    }
    const exponent = minorUnitExponent(currencyCode);
    const formatter = new Intl.NumberFormat(MONEY_LOCALE, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: exponent,
        maximumFractionDigits: exponent,
    });
    return formatter.format(amountInMinorUnits / Math.pow(DECIMAL_BASE, exponent));
}
